module.exports = __webpack_public_path__ + "img/iconSystemTruck.d0ce4722.svg";